import React, { useEffect, useState } from "react";
import "../css/sol.agent.info.css";
import CustomTooltip from "../../Atoms/CustomTooltip";
import { useSolution } from "../../../contexts/SolutionsContext";
import { CircularProgress } from "@mui/material";
const SolutionAgentInfo = ({ activeSolutionData }) => {
  const { agentsForSol, fetchAgents, isLoadingAgents, agentsFetchError } =
    useSolution();

  const [cardAnchorEl, setCardAnchorEl] = useState(null);
  const [hoveredAgent, setHoveredAgent] = useState(null);
  const [agentsToDisplay, setAgentsToDisplay] = useState([]);

  const handleHover = (e, agent) => {
    setCardAnchorEl(e.currentTarget);
    setHoveredAgent(agent);
  };

  const handleClose = () => {
    setCardAnchorEl(null);
    setHoveredAgent(null);
  };

  useEffect(() => {
    const getAgentsToDisplay = async () => {
      let agentsFromAPI =
        agentsForSol?.map((agent) => agent?.agent_id || "PH") || [];

      if (!!!agentsForSol?.length) {
        const response = await fetchAgents();

        if (!response) {
          return;
        }

        agentsFromAPI =
          response?.data?.map((agent) => agent?.agent_id || "PH") || [];
      }

      const currentAgents =
        activeSolutionData?.solution_metadata?.a2a?.skills?.map((skill) => ({
          id: skill?.id,
          name: skill?.name,
          description: skill?.description,
        })) || [];

      // Filter currentAgents to only include those available in agentsFromAPI
      const filteredAgents = currentAgents?.filter((currentAgent) =>
        agentsFromAPI?.includes(currentAgent?.id)
      );

      setAgentsToDisplay(
        !!filteredAgents?.length ? filteredAgents : currentAgents
      );
    };

    getAgentsToDisplay();
  }, [activeSolutionData, agentsForSol, fetchAgents]);

  useEffect(() => {
    if (agentsFetchError) {
      setAgentsToDisplay(activeSolutionData?.agents || []);
    }
  }, [agentsFetchError]);

  return (
    <>
      <div className="agent-info-container">
        <div className="row mb-3">
          <div className="col-md-12">
            <h3 className="agent-info-title">Agent Info</h3>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="agent-badges-container">
              {isLoadingAgents && (
                <div>
                  <CircularProgress
                    style={{ width: "15px", height: "15px", opacity: 0.8 }}
                  />
                </div>
              )}
              {agentsToDisplay?.map((agent, index) => (
                <div
                  key={index}
                  style={{
                    position: "relative",
                    display: "inline-block",
                    marginRight: "8px",
                    marginBottom: "8px",
                  }}
                >
                  <span
                    className="agent-badge"
                    onMouseEnter={(e) => handleHover(e, agent)}
                    onMouseLeave={handleClose}
                    style={{ cursor: "pointer" }}
                  >
                    {agent?.name || ""}
                  </span>
                  {cardAnchorEl && hoveredAgent === agent && (
                    <div className="solution-drawer-agent-tooltip">
                      <CustomTooltip
                        containerClsNames="marketplace-tooltip-container"
                        txtClsNames="marketplace-tooltip-txt"
                        arrowClsNames="marketplace-tooltip-arrow"
                        content={agent?.description || ""}
                        tooltipTitleClass="mas-tooltip-title"
                        anchorEl={cardAnchorEl}
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SolutionAgentInfo;
